import { useMutation, useQueryClient } from "@tanstack/react-query";
import { t } from "ttag";

import {
  applyCreditAmount,
  referralQueriesStore,
} from "@/features/referral/api";
import { errorToast, useToastStore } from "@/shared/ui";

export const useApplyReferralCreditAmount = () => {
  const pushToast = useToastStore((state) => state.pushToast);

  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: applyCreditAmount,
    onSuccess: () => {
      void pushToast({
        type: "success",
        title: t`Success`,
        message: t`Credit amount successfully applied!`,
      });
      void queryClient.invalidateQueries(referralQueriesStore.credit);
    },
    onError: errorToast,
  });
};
